export const defaultStatusTextColors = {
  active: "#17b61f",
  inactive: "#cb444a",
};

export const defaultStatusOuterColors = {
  active: "#17b61f23",
  inactive: "#cb444a33",
};
